<ng-container *ngIf="hideForClients.indexOf(hubName)<0">
    <div class="powered-by-wrap" [class.at-horizontal]="style.indexOf('horizontal')>=0" (click)="gotoITI()">
        <ng-container *ngIf="style==='full-vertical'">
            <div text>Powered by</div>
            <div class="flex">
                <img iti [src]="itiLogoUrl" alt="ITI" style="height: 18px">
                <span and>&</span>
                <img google [src]="googleLogoUrl" alt="Google" style="height: 23px">
            </div>
        </ng-container>
        <ng-container *ngIf="style==='iti-horizontal'">
            <div class="flex">
                <div text horizontal>Powered by</div>
                <img iti [src]="itiLogoUrl" alt="ITI" style="height: 18px">
            </div>
        </ng-container>
        <ng-container *ngIf="style==='iti-vertical'">
            <div iti-vertical>
                <div text>Powered by</div>
                <img iti [src]="itiLogoUrl" alt="ITI" style="height: 14px">
            </div>
        </ng-container>
    </div>
</ng-container>


// WEBPACK FOOTER //
// D:/Work/Development/ImGoing/IMGoing/web/src/common/components/powered.by/powered.by.component.html